import { render } from "./visualizar_turma.vue?vue&type=template&id=3c8f6f7e&scoped=true"
import script from "./visualizar_turma.vue?vue&type=script&lang=js"
export * from "./visualizar_turma.vue?vue&type=script&lang=js"

import "./visualizar_turma.vue?vue&type=style&index=0&id=3c8f6f7e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c8f6f7e"]])

export default __exports__